'use client';

import type { CSSProperties, ReactElement } from 'react';
import { Handle, Position } from '@xyflow/react';

const HANDLE_STYLE: CSSProperties = {
  width: 7,
  height: 7,
  backgroundColor: 'transparent',
  backgroundImage: 'none',
  border: 'none',
  opacity: 0,
  pointerEvents: 'none',
};

export interface FlowchartNodeHandlesProps {
  sourcePosition: Position | undefined;
  targetPosition: Position | undefined;
}

export function FlowchartNodeHandles({
  sourcePosition,
  targetPosition,
}: FlowchartNodeHandlesProps): ReactElement {
  return (
    <>
      <Handle type="target" position={targetPosition ?? Position.Top} style={HANDLE_STYLE} />
      <Handle type="source" position={sourcePosition ?? Position.Bottom} style={HANDLE_STYLE} />
    </>
  );
}
